<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import { Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, TabContent, TabPane } from "sveltestrap";
  import { error, success } from "../../../../../public/my-theme";
  import type { Fn } from "../../../../global";
  import type { Complainant } from "../../../../Model/Complainant";
  import type { Third } from "../../../../Model/Third";
import { complainantService } from "../../../../services";
  import ComplaintInfoForm from "../../ComplaintInfoForm.svelte";

  export let complainantThird: Third;
  export let diligenceId: string;
  export let open = false;
  export let toggle: Fn = undefined;

  $: load(diligenceId, complainantThird);

  let size = "lg";
  let complainant: Complainant;


  const dispatch = createEventDispatcher();

  async function load(diligenceId, complainantThird){
    if (diligenceId && complainantThird) {

      let complainants: Complainant[] = await complainantService.findByDiligenceNumber(diligenceId)
      complainant = complainants.find(c => c.complainantThirId == complainantThird.id)

    }
  }

  async function saveComplainantTraffic() {
    try {
      save()
      toggle()
      success("Datos guardados con exito");
    } catch (err) {
      error("Comprueba los campos");
    }
  }

  async function changeThirdList(third){
    complainant.complainantThirId = third.id;
    save()
  }

  async function save(){
    await Promise.all([ 
      complainantService.saveComplainant(complainant)
    ])
    dispatch('saveComplainant');
  }


</script>

<Modal isOpen={open} {toggle} {size}>
  <ModalHeader {toggle}>Editar</ModalHeader>
  <ModalBody>

    <!-- <TabContent>
      <TabPane tabId="Datos" tab="Datos" active> -->
        {#if complainant}
          <ComplaintInfoForm complainant={complainant} on:changeThirdLIst={(event) => changeThirdList(event.detail)}/>
        {/if}
      <!-- </TabPane>
    </TabContent> -->

  </ModalBody>
  <ModalFooter>
    <button class="btn btn-success" type="button" on:click={saveComplainantTraffic}>Guardar</button>
  </ModalFooter>
</Modal>

